import { ScopeRef } from "@/types/member";
import { api } from "./client";
import { Invitation } from "@/types/invitation";

export const invitationApi = {
  inviteInOrganisation: async (
    email: string,
    roleId: string,
    scope: ScopeRef[],
    sendEmail: boolean = true,
  ) => {
    const { data } = await api.post(`/api/v1/invites_v0/admin`, {
      email,
      role_id: roleId,
      scopes: scope.length ? scope : undefined,
      send_email: sendEmail,
    });
    return data;
  },

  inviteInCampaign: async (campaignId: string, email: string) => {
    try {
      const { data } = await api.post('api/v1/invites_v0/talent', {
        campaign_id: campaignId,
        email: email,
      });
      return data;
    } catch (error) {
      throw error;
    }
  },

  getInvitation: async (invitationId: string): Promise<Invitation> => {
    const { data } = await api.get(`/api/v1/invites_v0/${invitationId}`);
    return data;
  },

  getInvitationFromCampaign: async (campaignId: string): Promise<Invitation> => {
    const { data } = await api.get(`/api/v1/invites_v0/public/${campaignId}`);
    return data;
  },

  createCampaignPublicInvitation: async (campaignId: string): Promise<Invitation> => {
    const { data } = await api.post(`/api/v1/invites_v0/public`, { campaign_id: campaignId });
    return data;
  },

  deleteCampaignInvitation: async (invitationId: string) => {
    const { data } = await api.delete(`/api/v1/invites_v0/${invitationId}`);
    return data;
  },

  acceptInvitation: async (invitationId: string) => {
    const { data } = await api.post(`/api/v1/invites_v0/${invitationId}/apply`);
    return data;
  }

}